import { FilteringItem, Filters } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ToolsService } from '../../services/tools.service';
import { PostedFile } from '../models/filtersUtils.model';
import { FiltersService } from '../services/filters.service';

@Component({
  selector: 'app-filterfiles',
  templateUrl: './filterfiles.component.html',
  styleUrls: ['./filterfiles.component.scss'],
})
export class FilterfilesComponent implements OnInit, OnDestroy {
  @Input() tool: Filters;
  private subscriptions: Array<Subscription>;

  // Download current filtering into Template File
  public filteringdownload: SafeUrl;
  public filenametodownload: string;

  // Posted File to load filters
  public fileuploaded: PostedFile;

  public itemList: Array<FilteringItem> = [];

  constructor(
    private filtersService: FiltersService,
    private toolsService: ToolsService,
    private sanitizer: DomSanitizer
  ) {
    this.filenametodownload = this.filtersService.generateFilenameToDownload();

    this.fileuploaded = {
      status: 'pending',
      file: null,
    };
    this.subscriptions = [];
  }

  ngOnInit(): void {
    this.itemList = this.tool.data;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public downloadTemplate() {
    console.log(this.itemList);
    const parse_data = this.filtersService.itemListToHashDownload(this.itemList, {});
    const data = JSON.stringify(parse_data);
    this.filteringdownload = this.sanitizer.bypassSecurityTrustUrl(
      'data:text/json;charset=UTF-8,' + encodeURIComponent(data)
    );
  }
  // Read JSON file to assign venue, map, section, row, seat
  public postFileOpenModal($event: Event) {
    const target = $event.target as HTMLInputElement;
    const files = target.files as FileList;
    const selectedFile = files[0];
    this.fileuploaded.file = selectedFile;

    const fileReader = new FileReader();
    fileReader.readAsText(selectedFile, 'UTF-8');
    fileReader.onload = e => {
      const data = JSON.parse(fileReader.result.toString());
      this.tool.hashed = data;
      this.itemList = this.filtersService.parseHashToList(data, []);
      this.fileuploaded.status = 'done';

      console.log(this.itemList);
      console.log(data);
      this.filtersService.setListAndHash$({
        data: this.itemList,
        hash: data,
      });
    };
    fileReader.onerror = error => {
      console.log(error);
    };
  }

  // Clear posted file
  public postFileRemove($event?) {
    if ($event) {
      $event.target.value = '';
    } else {
      this.fileuploaded.file = null;
    }
    this.fileuploaded.status = 'pending';
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      this.tool = JSON.parse(JSON.stringify(res.filters));
      this.itemList = this.tool.data;
    });
    this.subscriptions.push(tools$);
  }
}
